export const texts = {
  title: {
    de: 'Seite nicht gefunden',
    en: 'Page not found'
  },
  toDashboard: {
    de: 'Zum Dashboard',
    en: 'To dashboard'
  }
};
